import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';
import { formatCurrency } from 'utils/NumberHelper';

const LeadProfileRecord = Record({
  completion: 0,
  revenue: 0,
  tradingPeriod: 0,
});

export default class LeadProfile extends LeadProfileRecord {
  static deserialize(jsonObject = {}) {
    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, {}), {});

    return new LeadProfile(hydrated);
  }

  get completionLabel() {
    const { completion } = this;

    if (completion >= 0 && completion < 40) {
      return 'More work to do';
    }

    if (completion >= 40 && completion < 65) {
      return 'Halfway there';
    }

    if (completion >= 65 && completion < 99) {
      return 'Almost there';
    }

    if (completion >= 99) {
      return 'Complete';
    }

    return '';
  }

  get completionValue() {
    return Math.floor(this.completion);
  }

  get subtitle() {
    return `${this.tradingPeriodInYears}yr old, ${formatCurrency(this.revenue)} turnover`;
  }

  get tradingPeriodInYears() {
    return Math.floor((this.tradingPeriod || 0) / 12);
  }
}
